export default __webpack_public_path__ + "static/wayne and vickie lackman-f5b1a513779c412abe28d64942dc1672.webp";